import { View, Utils } from '../vendor/kerneljs';

const SearchBar = View.extend({

	isActive: false,
	searchString: '',

	events: {
	},
	initialize: function(){
		this.htmlRef = Utils.find('html')[0];
		this.bodyRef = Utils.find('body')[0];

		this.searchButton = this.find('.js--search-field-toggle');
		this.searchField = this.find('.search__field');
		this.searchFieldInput = this.find('input[type=text]');

		this.eventEmitter.on('menu:open', this.forceClose.bind(this) );
		this.eventEmitter.on('search:forceclose', this.forceClose.bind(this) );
		this.eventEmitter.on('search:forceopen', this.forceOpen.bind(this) );

		Utils.on(this.bodyRef,'click', this.bodyClick.bind(this));
	},
	onToggle: function() {
		if ( !this.isActive ) {
			this.eventEmitter.emit('searchbar:open');
			this.open();
		}
		else {
			this.forceClose("");
			this.eventEmitter.emit('searchbar:close');
		}

	},

	forceOpen: function() {
		Utils.addClass(this.searchField,'is-active');
		Utils.addClass(this.searchButton,'is-active');
		this.isActive = true;
	},

	open:function() {

		if ( window.innerWidth < 950) return false;

		Utils.addClass(this.searchField,'is-active');
		Utils.addClass(this.searchButton,'is-active');

		this.isActive = true;
		this.searchFieldInput.focus();

		this.eventEmitter.emit('menu:open', this.instanceId);

		Utils.addClass(this.htmlRef,'is-search-mode');

	},
	forceClose:function(instanceId){

		if ( window.innerWidth < 950) return false;

		if ( typeof instanceId === "undefined") {}
		else if ( instanceId === this.instanceId ) return false;

		if ( this.searchField instanceof HTMLElement ) {
			Utils.removeClass(this.searchField,'is-active');
			Utils.removeClass(this.searchButton,'is-active');
			this.isActive = false;
			Utils.removeClass(this.htmlRef,'is-search-mode');
		}
	},

	bodyClick:function(event) {

		if ( window.innerWidth < 950) return false;

		let search = Utils.closestByClass(event.target,'js--search-bar');
		let searchButton = Utils.closestByClass(event.target,'js--search-field-toggle');

		if ( search ) {
			if ( searchButton ) this.onToggle();
		}
		else {
			this.eventEmitter.emit('searchbar:close');
			this.forceClose();
		}
	}
});
(function(){
	Utils.each(Utils.find('.js--search-bar'), function(elem) {
		new SearchBar( {el: elem} );
	});

})();

export default SearchBar;